(() => {
  const QUALIFYING_PRODUCT_IDS = new Set([
    10954010001735, // ATLAS Tee Cream
    10954004398407, // WEB Tee Coal
    10866936217927, // ASTERiSK Tee Cream
    10866937921863  // ASTERiSK Tee Coal
  ]);

  const SHORTS_HANDLE = 'shorts';
  const SIZE_ORDER = ['S', 'M', 'L', 'XL', 'XXL'];

  const GIFT_PROPERTY = '_free_tee_gift';
  const GIFT_SIZE_PROPERTY = '_free_tee_gift_size';

  const shopFetch = window.fetch.bind(window);

  let syncing = false;

  async function getCart() {
    const response = await shopFetch(
      `${window.Shopify.routes.root}cart.js`,
      {
        headers: { Accept: 'application/json' }
      }
    );

    if (!response.ok) throw new Error('Nepodařilo se načíst košík.');

    return response.json();
  }

  async function getShortsProduct() {
    const response = await shopFetch(
      `${window.Shopify.routes.root}products/${SHORTS_HANDLE}.js`,
      {
        headers: { Accept: 'application/json' }
      }
    );

    if (!response.ok) {
      throw new Error('Nepodařilo se načíst varianty kraťasů.');
    }

    return response.json();
  }

  function getTeeSize(item) {
    if (Array.isArray(item.options_with_values)) {
      const sizeOption = item.options_with_values.find(
        option =>
          option.name.toLowerCase().includes('velik') ||
          option.name.toLowerCase().includes('size')
      );

      if (sizeOption) return sizeOption.value;
    }

    if (Array.isArray(item.variant_options)) {
      return item.variant_options[0];
    }

    return item.variant_title;
  }

  function findClosestAvailableVariant(size, shortsProduct) {
    const availableVariants = shortsProduct.variants.filter(
      variant => variant.available
    );

    const exact = availableVariants.find(
      variant => variant.option1 === size
    );

    if (exact) return exact;

    const requestedIndex = SIZE_ORDER.indexOf(size);

    if (requestedIndex === -1) {
      return availableVariants[0] || null;
    }

    // Nejprve hledáme stejně vzdálenou VĚTŠÍ velikost,
    // potom menší.
    for (let distance = 1; distance < SIZE_ORDER.length; distance++) {
      const largerIndex = requestedIndex + distance;

      if (largerIndex < SIZE_ORDER.length) {
        const largerSize = SIZE_ORDER[largerIndex];

        const largerVariant = availableVariants.find(
          variant => variant.option1 === largerSize
        );

        if (largerVariant) return largerVariant;
      }

      const smallerIndex = requestedIndex - distance;

      if (smallerIndex >= 0) {
        const smallerSize = SIZE_ORDER[smallerIndex];

        const smallerVariant = availableVariants.find(
          variant => variant.option1 === smallerSize
        );

        if (smallerVariant) return smallerVariant;
      }
    }

    return null;
  }

  async function addGift(variantId, quantity, size) {
    const response = await shopFetch(
      `${window.Shopify.routes.root}cart/add.js`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity,
              properties: {
                [GIFT_PROPERTY]: 'true',
                [GIFT_SIZE_PROPERTY]: size
              }
            }
          ]
        })
      }
    );

    if (!response.ok) {
      throw new Error('Nepodařilo se přidat kraťasy zdarma.');
    }
  }

  async function changeGift(lineKey, quantity) {
    const response = await shopFetch(
      `${window.Shopify.routes.root}cart/change.js`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: lineKey,
          quantity
        })
      }
    );

    if (!response.ok) {
      throw new Error('Nepodařilo se upravit kraťasy zdarma.');
    }
  }

  async function syncFreeShorts() {
    if (syncing) return;

    syncing = true;

    try {
      const [cart, shortsProduct] = await Promise.all([
        getCart(),
        getShortsProduct()
      ]);

      const desired = new Map();

      for (const item of cart.items) {
        if (!QUALIFYING_PRODUCT_IDS.has(Number(item.product_id))) {
          continue;
        }

        const teeSize = getTeeSize(item);
        const shortsVariant = findClosestAvailableVariant(
          teeSize,
          shortsProduct
        );

        if (!shortsVariant) continue;

        const variantId = Number(shortsVariant.id);

        if (!desired.has(variantId)) {
          desired.set(variantId, {
            quantity: 0,
            size: shortsVariant.option1
          });
        }

        desired.get(variantId).quantity += item.quantity;
      }

      const giftItems = cart.items.filter(
        item =>
          item.properties &&
          item.properties[GIFT_PROPERTY] === 'true'
      );

      let changed = false;

      // Upravíme nebo odstraníme existující dárkové kraťasy
      for (const gift of giftItems) {
        const variantId = Number(gift.variant_id);
        const wanted = desired.get(variantId);

        if (!wanted) {
          await changeGift(gift.key, 0);
          changed = true;
          continue;
        }

        if (gift.quantity !== wanted.quantity) {
          await changeGift(gift.key, wanted.quantity);
          changed = true;
        }

        desired.delete(variantId);
      }

      // Přidáme varianty, které ještě chybí
      for (const [variantId, data] of desired.entries()) {
        if (data.quantity > 0) {
          await addGift(
            variantId,
            data.quantity,
            data.size
          );

          changed = true;
        }
      }

      if (changed) {
        window.location.reload();
      }
    } catch (error) {
      console.error('[Free Shorts]', error);
    } finally {
      syncing = false;
    }
  }

  document.addEventListener('DOMContentLoaded', syncFreeShorts);

  document.addEventListener('change', () => {
    setTimeout(syncFreeShorts, 700);
  });

  document.addEventListener('click', event => {
    if (
      event.target.closest(
        'button, cart-remove-button, quantity-input, [name="add"]'
      )
    ) {
      setTimeout(syncFreeShorts, 900);
    }
  });

  window.fetch = async (...args) => {
    const response = await shopFetch(...args);

    try {
      const url = String(args[0]);

      if (
        url.includes('/cart/add') ||
        url.includes('/cart/change') ||
        url.includes('/cart/update')
      ) {
        setTimeout(syncFreeShorts, 600);
      }
    } catch (error) {
      console.error('[Free Shorts]', error);
    }

    return response;
  };
})();